import React from 'react';
import { TrendingUp, Clock, Shield, Users } from 'lucide-react';
import { useScrollReveal } from '@/hooks/use-scroll-reveal';

const stats = [
  {
    icon: TrendingUp,
    number: "3-6 months",
    label: "Faster to market",
    description: "While competitors struggle with development"
  },
  {
    icon: Shield,
    number: "60% less",
    label: "Technical debt", 
    description: "Clean, maintainable code from day one"
  },
  {
    icon: Clock,
    number: "2-4 weeks",
    label: "Average project start",
    description: "Most agencies take months just to begin"
  },
  {
    icon: Users,
    number: "100%",
    label: "Client satisfaction",
    description: "Clear communication throughout"
  }
];

export const ResultsSection = () => {
  const { elementRef, getRevealStyle } = useScrollReveal();

  return (
    <section className="section">
      <div className="container-professional">
        {/* Header */}
        <div className="section-header-professional">
          <div className="micro-label-professional">PROVEN RESULTS</div>
          <h2 className="heading-section">
            Results that matter
          </h2>
          <p className="text-body max-w-2xl mx-auto" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>
            We measure success by your business outcomes, not just code delivery
          </p>
        </div>

        {/* Stats Grid */}
        <div ref={elementRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            
            return (
              <div 
                key={stat.label}
                className="bg-[#111111] border border-[rgba(255,255,255,0.15)] rounded-xl p-6 text-center transition-all duration-200 hover:border-[rgba(255,255,255,0.25)] hover:transform hover:-translate-y-1"
                style={getRevealStyle(index)}
              >
                {/* Icon */}
                <div className="mb-6">
                  <Icon 
                    className="w-8 h-8 mx-auto" 
                    strokeWidth={1.5}
                    style={{ color: '#00e5ff' }}
                  />
                </div>
                
                {/* Number */}
                <div className="text-3xl font-bold text-white mb-2">
                  {stat.number}
                </div>
                
                {/* Label */}
                <div className="text-sm font-semibold text-white mb-3">
                  {stat.label}
                </div>
                
                {/* Description */}
                <p className="text-xs leading-relaxed" style={{ color: 'rgba(255, 255, 255, 0.6)' }}>
                  {stat.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};